import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ChevronRight } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface Crumb {
    label: string
    href?: string
}

interface BreadcrumbsProps {
    items: Crumb[]
    className?: string
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ items, className }): ReactNode => {
    return (
        <nav aria-label='Breadcrumb' className={className}>
            <ol className='flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground'>
                {items.map((crumb, index) => {
                    const isLast = index === items.length - 1

                    return (
                        <li key={`${crumb.label}-${index}`} className='inline-flex items-center gap-1.5'>
                            {crumb.href && !isLast ? (
                                <Link href={crumb.href} className='transition-colors hover:text-primary'>
                                    {crumb.label}
                                </Link>
                            ) : (
                                <span className={cn(isLast && 'text-foreground')}>
                                    {crumb.label}
                                </span>
                            )}

                            {!isLast && <ChevronRight className='size-3.5 text-muted-foreground/50' />}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}
